/* eslint-disable no-unused-vars */
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';
import {
  creativesActions,
  generalActions,
  formErrorsCampaign_action,
  trackingActions,
  targetingPlacementsActions,
} from 'store/actions';
import Loader from 'components/common/loader/Loader';
import Box from '@mui/material/Box';
import { CampaignMain, ErrorComponent } from 'components';
import { campaignEnvironment } from 'constants';
import * as S from '../editCampaign/EditCampaign.styled';
import { select_current_campaign_obj } from 'store/selectors';
//import { updateRecievedTargetingLocations } from 'utils';
import uuid from 'react-uuid';
import { NEW_CAMP_STAB_DEFAULT_CREATIVE, NEW_CAMP_STAB_DEFAULT_TRACKING } from 'constants';
import { cloneDeep } from 'lodash-es';

const NewCampaign_emptyPage = () => {
  const {
    data: campaignData,
    isError: isErrorCampData,
    isSuccess: isSuccessCampData,
    isFetching: isFetchingCampData,
  } = saveCampaignServiceAPI.useGetCampaignData_newEmptyQuery();
  const currentCampaignObj = useSelector(select_current_campaign_obj);
  const creativeAndTrackingData = useSelector((state) => state.creatives.creativeAndTrackingData);

  const location = useLocation();

  // useEffect(() => {
  //   //if (creativeAndTrackingData.app_icon || !creativeAndTrackingData.app_icon) {
  //   const newTmpCreativeId = uuid();
  //   let newCreativeListData = [];
  //   let newTmpCreative = structuredClone(NEW_CAMP_STAB_DEFAULT_CREATIVE);

  //   newTmpCreative.bn_bannerid = newTmpCreativeId;
  //   newTmpCreative.tmp_id = newTmpCreativeId;
  //   newTmpCreative.title = '';
  //   newTmpCreative.name = '';
  //   newTmpCreative.status = 0;
  //   newTmpCreative.icon = creativeAndTrackingData.app_icon ?? '';
  //   newTmpCreative.video_landscape = creativeAndTrackingData.store_video_url ?? '';
  //   newTmpCreative.icon_media_id = creativeAndTrackingData.app_icon_media_id ?? '';
  //   newTmpCreative.image = creativeAndTrackingData.app_image ?? '';
  //   newTmpCreative.image_media_id = creativeAndTrackingData.app_image_media_id ?? '';
  //   newCreativeListData.push(newTmpCreative);
  //   const newTrackingforDefaultItem = structuredClone(NEW_CAMP_STAB_DEFAULT_TRACKING);
  //   newTrackingforDefaultItem.tmp_id = newTmpCreativeId;
  //   newTrackingforDefaultItem.bn_bannerid = newTmpCreativeId;

  //   console.log({ newCreativeListData });
  //   console.log({ newTrackingforDefaultItem });
  //   //dispatch(creativesActions.setCreativesList(newCreativeListData));
  //   //dispatch(creativesActions.addTrackingDataForCreative(newTrackingforDefaultItem));
  //   // }
  // }, [creativeAndTrackingData.app_icon, creativeAndTrackingData.link_state_model_dic]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const app = queryParams.get('app');
    if (!isFetchingCampData && campaignData) {
      if (app !== null) {
        const updatedCampaignData = structuredClone(campaignData);
        updatedCampaignData.currentCampaignObj.app = app;
        dispatch(generalActions.setCampaignDataForID(updatedCampaignData));
        dispatch(creativesActions.resetTrackingAndCreative());
      } else {
        dispatch(generalActions.setCampaignDataForID(campaignData));
      }
      //updateRecievedTargetingLocations(campaignData?.selected_locations);
    }
  }, [campaignData, isFetchingCampData]);

  const dispatch = useDispatch();

  const loaderFlag = useMemo(() => {
    const campaignDataLoader = (!isSuccessCampData && !isErrorCampData) || isFetchingCampData;
    return campaignDataLoader;
  }, [isSuccessCampData, isErrorCampData, isFetchingCampData]);

  useEffect(() => {
    dispatch(generalActions.setCampaignEnvironment(campaignEnvironment.new_empty));
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      console.log('Page is being closed, clearing Redux state');
      dispatch(generalActions.setDefaultState());
      dispatch(creativesActions.setDefaultState());
      dispatch(targetingPlacementsActions.clearState());
      dispatch(formErrorsCampaign_action.resetErrors());
      dispatch(trackingActions.resetTrackingError());
    };
    return () => {
      handleBeforeUnload();
    };
  }, []);

  return (
    <>
      {isErrorCampData && <ErrorComponent />}
      {loaderFlag && <Loader.Global delay={1} />}
      {currentCampaignObj !== undefined && (
        <>
          <S.PageMainHeader>New Campaign</S.PageMainHeader>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '964px 200px',
              gap: 4,
              margin: 'auto',
              marginBottom: '50px',
              width: '964px',
              gridTemplateRows: 'auto',
              gridTemplateAreas: `"main sidebar"`,
            }}
          >
            <Box sx={{ gridArea: 'main' }}>
              <CampaignMain environment={campaignEnvironment.new_empty} />
            </Box>
            <Box sx={{ gridArea: 'sidebar' }}>{/* <RecommendationsFloatingSideBar /> */}</Box>
          </Box>
        </>
      )}
    </>
  );
};

export default NewCampaign_emptyPage;
